module.exports = __webpack_public_path__ + "images/b15f302713fd7533c991d875cf8bbba8.svg";